// eslint-disable-next-line import/prefer-default-export
export const extractUUID = (value: string) => (
  value.match(/(?<uuid>[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12})/i)?.groups?.uuid
);
